module.exports = __webpack_public_path__ + "static/media/hot75.d3541699.jpg";